import { useState } from 'react';

import styles from '@/admin/components/AdminEntityIdentity.module.scss';
import type { FileDto } from '@/api/api.dto';
import { imageVariantLink } from '@/common/media';
import { AuthorizedImage } from '@/components/AuthorizedImage';

type AdminEntityIdentityProps = {
  name: string;
  image: FileDto | null;
  details?: string;
};

/** A vessel or a service provider: its picture, or its initial when it has none, then its name. */
export const AdminEntityIdentity = ({ name, image, details }: AdminEntityIdentityProps) => {
  const [failedImage, setFailedImage] = useState<string | null>(null);
  const link = imageVariantLink(image, 32);
  const shown = link !== failedImage ? link : null;

  return (
    <div className={styles.entity}>
      {/* Fixed slot: the letter shows until the image loads, and stays if it never does. */}
      <span className={styles.thumb}>
        {name[0]?.toUpperCase() ?? '?'}
        <AuthorizedImage
          className={styles.image}
          src={shown}
          alt=""
          onError={() => setFailedImage(link)}
        />
      </span>
      <div className={styles.entityText}>
        <span className={styles.name}>{name}</span>
        {details && <span className={styles.muted}>{details}</span>}
      </div>
    </div>
  );
};
